import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleRipple } from '../../../helpers/ripple';
import {
  ContentContainer,
  Contentwrapper,
  Stepimage,
  StyledContentBlock,
  StyledSection,
  Title,
  Step1,
  Stepwrapper,
  Step2,
  Step3,
  Steplower,
  StepTitle,
  StepContentwrapper,
  StepSubtitle,
  Topwrapper,
  Bluewrapper,
  BlueTitle,
  Iconwrapper,
  Appstore,
  Appstoreicon,
  Playstoreicon,
  Playstore,
  Stepimagemobile,
  Step1imagewrapper,
  Step2imagewrapper,
  Step3imagewrapper,
  Button,
  ButtonText,
  Blackcircle,
} from './styled';
import QrCodeModal from '../QrCodeModalCrypto';

const FreeCrypto = () => {
  const { formatMessage } = useIntl();
  const step1src = formatMessage({ id: 'home.freecrypto.step1.image.src' });
  const step1mobilesrc = formatMessage({
    id: 'home.freecrypto.step1.image.mobilesrc',
  });
  const step1alt = formatMessage({ id: 'home.freecrypto.step1.image.alt' });
  const step2mobilesrc = formatMessage({
    id: 'home.freecrypto.step2.image.mobilesrc',
  });
  const step2src = formatMessage({ id: 'home.freecrypto.step2.image.src' });
  const step2alt = formatMessage({ id: 'home.freecrypto.step2.image.alt' });
  const step3mobilesrc = formatMessage({
    id: 'home.freecrypto.step3.image.mobilesrc',
  });
  const step3src = formatMessage({ id: 'home.freecrypto.step3.image.src' });
  const step3alt = formatMessage({ id: 'home.freecrypto.step3.image.alt' });
  const appstoresrc = formatMessage({
    id: 'home.freecrypto.appstoreimage.src',
  });

  const appstorealt = formatMessage({
    id: 'home.freecrypto.appstoreimage.alt',
  });

  const appstorelink = formatMessage({
    id: 'home.freecrypto.appstoreimage.link',
  });

  const playstoresrc = formatMessage({
    id: 'home.freecrypto.playstoreimage.src',
  });

  const playstorealt = formatMessage({
    id: 'home.freecrypto.playstoreimage.alt',
  });

  const playstorelink = formatMessage({
    id: 'home.freecrypto.playstoreimage.link',
  });

  // const qrSrc = formatMessage({
  //   id: 'home.freecrypto.qrimage.src',
  // });
  // const qralt = formatMessage({
  //   id: 'home.freecrypto.qrimage.alt',
  // });
  const Iconsrc = formatMessage({
    id: 'home.freecrypto.Icon',
  });

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title>
            <FormattedMessage id="home.freecrypto.title" />
          </Title>
          <ContentContainer>
            <Topwrapper>
              <Stepwrapper>
                <Step1>
                  <Step1imagewrapper>
                    <Stepimage src={step1src} alt={step1alt} />
                    <Stepimagemobile src={step1mobilesrc} alt={step1alt} />
                  </Step1imagewrapper>
                  <Steplower>
                    <StepContentwrapper>
                      <StepTitle>
                        <FormattedMessage id="home.freecrypto.step1.title" />
                      </StepTitle>
                      <StepSubtitle>
                        <FormattedMessage id="home.freecrypto.step1.subtitle" />
                      </StepSubtitle>
                      <Button
                        onMouseEnter={handleRipple}
                        onClick={() =>
                          window.open(
                            'https://bitcoincom.app.link/XcEjsS1zmBb?_p=c11433dc9a0a7af2e11e90f5ef',
                            '_blank',
                          )
                        }
                      >
                        <ButtonText>
                          <FormattedMessage id="home.freecrypto.mobilebutton" />
                        </ButtonText>
                        <Blackcircle src={Iconsrc} />
                      </Button>
                    </StepContentwrapper>
                  </Steplower>
                </Step1>
                <Step2>
                  <Step2imagewrapper>
                    <Stepimage src={step2src} alt={step2alt} />
                    <Stepimagemobile src={step2mobilesrc} alt={step2alt} />
                  </Step2imagewrapper>
                  <Steplower>
                    <StepContentwrapper>
                      <StepTitle>
                        <FormattedMessage id="home.freecrypto.step2.title" />
                      </StepTitle>
                      <StepSubtitle>
                        <FormattedMessage id="home.freecrypto.step2.subtitle" />
                      </StepSubtitle>
                    </StepContentwrapper>
                  </Steplower>
                </Step2>
                <Step3>
                  <Step3imagewrapper>
                    <Stepimage src={step3src} alt={step3alt} />
                    <Stepimagemobile src={step3mobilesrc} alt={step3alt} />
                  </Step3imagewrapper>
                  <Steplower>
                    <StepContentwrapper>
                      <StepTitle>
                        <FormattedMessage id="home.freecrypto.step3.title" />
                      </StepTitle>
                      <StepSubtitle>
                        <FormattedMessage id="home.freecrypto.step3.subtitle" />
                      </StepSubtitle>
                    </StepContentwrapper>
                  </Steplower>
                </Step3>
              </Stepwrapper>
            </Topwrapper>
            <Bluewrapper>
              <BlueTitle>
                <FormattedMessage id="home.freecrypto.downloadtitle" />
              </BlueTitle>
              <Iconwrapper>
                <Appstore href={appstorelink} target="_blank">
                  <Appstoreicon src={appstoresrc} alt={appstorealt} />
                </Appstore>
                <Playstore href={playstorelink} target="_blank">
                  <Playstoreicon src={playstoresrc} alt={playstorealt} />
                </Playstore>
                <QrCodeModal />
              </Iconwrapper>
            </Bluewrapper>
          </ContentContainer>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default FreeCrypto;

export const freeCryptoFragment = graphql`
  fragment FreeCrypto on Json {
    freecrypto {
      title
      mobilebutton
      Icon
      step1 {
        title
        subtitle
        image {
          src
          mobilesrc
          alt
        }
      }
      step2 {
        title
        subtitle
        image {
          src
          mobilesrc
          alt
        }
      }
      step3 {
        title
        subtitle
        image {
          src
          mobilesrc
          alt
        }
      }
      downloadtitle
      playstoreimage {
        src
        alt
        link
      }
      appstoreimage {
        src
        alt
        link
      }
      qrimage {
        src
        alt
      }
    }
  }
`;
